import { useSearchParams } from 'react-router-dom';
import { AtSign, Bell, LayoutTemplate, Mail } from 'lucide-react';
import { PageHeader } from '@/shared/components/page-header';
import { SegmentedControl } from '@/shared/ui/segmented-control';
import { EmailTemplatesPage } from '@/features/email-marketing';
import { SenderTab } from './sender-tab';
import { SystemEmailsTab } from './system-emails-tab';
import { SystemPushesTab } from './system-pushes-tab';

type Tab = 'emails' | 'templates' | 'pushes' | 'remetente';

const TABS: Array<{ value: Tab; label: string; icon: typeof Mail }> = [
  { value: 'emails', label: 'E-mails', icon: Mail },
  { value: 'templates', label: 'Templates', icon: LayoutTemplate },
  { value: 'pushes', label: 'Pushes', icon: Bell },
  { value: 'remetente', label: 'Remetente', icon: AtSign },
];

function readTab(value: string | null): Tab {
  return TABS.some((tab) => tab.value === value) ? (value as Tab) : 'emails';
}

/** Configurações gerais da plataforma: o que o sistema manda sozinho e de onde manda. */
export function PlatformPage() {
  const [params, setParams] = useSearchParams();
  const tab = readTab(params.get('aba'));
  const setTab = (next: Tab) => {
    const copy = new URLSearchParams(params);
    if (next === 'emails') copy.delete('aba');
    else copy.set('aba', next);
    setParams(copy, { replace: true });
  };
  const nav = <SegmentedControl value={tab} onChange={setTab} options={TABS} size="sm" />;

  // Templates: as ações da biblioteca (importar, criar) ficam na linha do título,
  // as abas da plataforma logo abaixo e o filtro de categoria depois.
  if (tab === 'templates') return <EmailTemplatesPage frame={{ title: 'Plataforma', nav }} />;

  return (
    <div className="space-y-4">
      <PageHeader title="Plataforma" />
      {nav}
      {tab === 'emails' ? <SystemEmailsTab /> : null}
      {tab === 'pushes' ? <SystemPushesTab /> : null}
      {tab === 'remetente' ? <SenderTab /> : null}
    </div>
  );
}
